import { useState } from 'react'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { BrokeNotificationQueryKeys } from '@/modules/client-setting/keys'
import { BrokeNotificationData } from '@/modules/client-setting/type'
import useMutationDeleteBrokeNotification from '@/modules/client-setting/api/hooks/useMutationDeleteBrokeNotification'
import { Trash2Icon } from 'lucide-react'
import { AlertModal } from '@/common/shared/alert-modal'

interface DeleteBrokeNotificationProps {
	data: BrokeNotificationData
}

export default function DeleteBrokeNotification({
	data,
}: DeleteBrokeNotificationProps) {
	const [open, setOpen] = useState(false)
	const [loading, setLoading] = useState(false)
	const { mutate: deleteBrokeNotification } =
		useMutationDeleteBrokeNotification()
	const queryClient = useQueryClient()

	const onConfirm = () => {
		setLoading(true)
		deleteBrokeNotification(
			{ id: data.id },
			{
				onSuccess: () => {
					toast.success('ลบประกาศสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [BrokeNotificationQueryKeys.GetBrokeNotifications],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
				onSettled: () => {
					setLoading(false)
				},
			},
		)
	}

	return (
		<>
			<AlertModal
				isOpen={open}
				onClose={() => setOpen(false)}
				onConfirm={onConfirm}
				loading={loading}
				title="คุณแน่ใจหรือไม่?"
				description={`คุณต้องการลบประกาศ "${data.title}" หรือไม่?`}
			/>
			<Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
				<Trash2Icon className="size-4" />
			</Button>
		</>
	)
}
